import React, { useState } from "react";
import cookie from 'react-cookies';
import styled from "styled-components";
import Common from "../based/Common";
import Logo from "./components/Image/LogoArtist.svg";
import "@fontsource/lexend";


function AccessDenied(props) {
    const isDesktop = window.innerWidth > 768

    const handleLogout = () =>{
        Common.RemoveToken();
        cookie.remove('token');
        window.location.href = '/login';
          
    }
   
    return (
        <AccessDeniedStyle>
            <div className="artist">
                        <nav>
                            <div className="logo">
                                <img src={Logo} alt="logo" />
                            </div>
                        </nav>
                        <div className="body-artist">
                            <header>
                                <div className="user-info">
                                    <div className="name-user">
                                        <span>Xin chào</span>
                                    </div>
                                </div>
                                <div className="right-info">
                                    <span onClick={()=>{
                                        handleLogout()
                                    }}>Đăng xuất</span>
                                </div>
                            </header>
                            <main>
                                <div className="box-verify">
                                    <div className="title-verify">Cấp quyền tài khoản</div>
                                    <div className="desc-verify">Artist vui lòng liên hệ Ranus để được cấp quyền cho tài khoản</div>
                                </div>
                                {!isDesktop && <span className="logout-span" onClick={()=>{
                                        handleLogout()
                                    }}>Đăng xuất</span>}
                            </main>
                        </div>
                    </div>
            
            
        </AccessDeniedStyle>
    );
}
const AccessDeniedStyle = styled.div`
    font-family: "Lexend";
    font-style: normal;

    .artist {
        width: 100%;
        margin: 0 auto;
        position: relative;

        .body-artist {
            margin-left: ${window.innerWidth > 1024 ? "calc(1024px / 5)" : "20%"};
            width: ${window.innerWidth > 1024 ? "calc(100% - 1024px / 5)" : "80%"};
            min-height: 100svh;
            background-color: #313131;

            header {
                height: 142px;
                width: 100%;
                background-color: #313131;
                padding:0 24px;
                display: flex;
                align-items: center;
                justify-content: space-between;


                .right-info{
                    display: flex;
                    align-items: center;

                    span{
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 18px;
                        letter-spacing: -0.3px;
                        color: #06F1B9;
                        margin-left: 25px;
                        cursor: pointer;
                    }
                }

                .user-info {
                    display: flex;
                    align-items: center;

                    .avatar-user {
                        width: 42px;
                        height: 42px;

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            border-radius: 50%;
                        }
                    }
                    .name-user {
                        margin-left: 21px;

                        span {
                            font-weight: 600;
                            font-size: 20px;
                            line-height: 25px;
                            letter-spacing: -0.3px;
                            color: #ffffff;

                            &.name {
                                color: #06f1b9;
                                margin-left: 7px;
                            }
                        }
                    }
                }
            }

            main {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;

                .logout-span{
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 18px;
                    letter-spacing: -0.3px;
                    color: #06F1B9;
                    margin-left: 25px;
                    cursor: pointer;
                    display: block;
                    margin-top: 25px;
                }
                
                .message-error{
                    text-align: left;
                    color: red;
                    font-size: 14px;
                }
            
                .logo-verify{
                    display: block;
                    position: absolute;
                    top: 20px;
                    left: 20px;
                }
            
                   
                .box-verify{
                    max-width: 95%;
                    width: 470px;
                    padding: 16px;
                    background-color: #313131;   
                    background: #464646;
                    border-radius: 10px;
                    text-align: center;
            
                    .title-verify{
                        font-weight: 600;
                        font-size: 25px;
                        line-height: 31px;
                        letter-spacing: -0.3px;
                        color: #FFFFFF;
                        
                    }
                    .send-more{
                        text-decoration: underline;
                        margin-top: -20px !important;
                        cursor: pointer;
                    }
            
                    .desc-verify{
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 18px;
                        letter-spacing: -0.3px;
                        color: #06F1B9;
                        margin: 12px 0 32px;
                    }
            
                    .input-submit{
                        display: flex;
                        align-items: center;
                        input{
                            flex-grow: 1;
                            height: 42px;
                            background: #3A3A3A;
                            border-radius: 10px;
                            padding: 0 17px;
                            border: none;
                            outline: none;
                            color: #fff;
            
                            :placeholder{
                                font-weight: 400;
                                font-size: 14px;
                                line-height: 18px;
                                letter-spacing: -0.3px;
                                color: #FFFFFF;
                                opacity: 0.2;
                            }
                        }
            
                        button{
                            width: 114px;
                            height: 42px;
                            background: linear-gradient(259.14deg, #06F1B9 1.32%, #008263 100%);
                            border-radius: 10px;
                            font-weight: 600;
                            font-size: 16px;
                            line-height: 20px;
                            letter-spacing: -0.3px;
                            color: #FFFFFF;
                            display: grid;
                            place-items: center;
                            border: none;
                            margin-left: 16px;
                            outline: none;
                        }
                    }
                }
            }
        }

        nav {
            position: fixed;
            top: 0;
            bottom: 0;
            width: 20%;
            max-width: calc(1024px / 5);
            background-color: #3a3a3a;

            .logo {
                height: 142px;
                width: 100%;
                display: grid;
                place-items: center;

                img {
                    width: 116px;
                    height: 43px;
                    object-fit: contain;
                }
            }

            
        }
    }

    
    @media (max-width: 768px){
        .artist {
          
    
            .body-artist {
                margin-left: 0;
                width: 100%;
         
    
                header {
                    padding:16px;
                    height: auto;
                    .right-info{
                        display: none;
                    }
    
                    .user-info {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        flex-direction: row-reverse;
                        width: 100%;

                        .avatar-user {
                           
                           
                        }
                        .name-user {
                            margin-left: 0;
                        }
                    }
                }
    
                main {
                    .box-verify{
                        margin-top: 100px;
                    }
                }
            }
    
            nav {
                display: none;
                
            }
        }
    }


    
        
    
    
`;
export default AccessDenied;



// WEBPACK FOOTER //
// ./src/artist-ui/AccessDenied.js